import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import CanceledIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const Config = {
  ACTIVE: {
    key: "ACTIVE",
    name: "Active",
    icon: <PersonIcon />,
  },
  DEACTIVATED: {
    key: "DEACTIVATED",
    name: "Deactivated",
    icon: <CanceledIcon />,
  },
  INVITATION_PENDING: {
    key: "INVITATION_PENDING",
    name: "Invitation Pending",
    icon: <AccessTimeIcon />,
  },
};

export default Config;
